export const PATH_ACTIVATE = '/coupon/access-code';
export const PATH_SIGNUP_AND_ACTIVATE = '/activation';
export const PATH_SIGNUP_AND_ACTIVATE_PL = '/aktywacja';
export const PATH_THANKYOU = '/thankyou-activation';
